import { IPropsWithChildren } from '@omaze/app';
import classNames from 'classnames';
import React, { ReactElement } from 'react';

import styles from './Highlight.module.css';
import { highlightDisplayName } from './Highlight.qa';

export interface IHighlightProps extends IPropsWithChildren {
    'data-testid'?: string;
    className?: string;
}

export function OzHighlight (props: IHighlightProps): ReactElement {
    const {
        'data-testid': dataTestId,
        className = '',
        children,
    }: IHighlightProps = props;

    if (!children) {
        throw new Error('Missing children prop');
    }

    if (!React.isValidElement(children)) {
        throw new Error('Children is not a valid react element');
    }

    const highlightTextClassNames: string = classNames({
        [styles.highlightBackground]: true,
        [children.props.className]: !!children.props.className,
    });

    return (
        <div className={`inline-block text-rebrand-navy-900 ${className}`} data-testid={dataTestId}>
            {React.cloneElement(children, {
                className: `inline ${highlightTextClassNames}`,
            })}
        </div>
    );
}

OzHighlight.displayName = highlightDisplayName;
